import { useState } from "react";
import PropTypes from "prop-types";

import { languages, strCode } from "../../../../consts";
import { t } from "../../../../services";

import {
  FlexContainers,
  IconButton,
  Paragraph2,
  SVG,
  WrapperContainer
} from "../../../../components";
import DeleteLanguageModal from "./DeleteLanguageModal";
import { LanguageItemWrapper } from "./styled";

const getLanguageName = (lang) => {
  const language = languages.find((l) => l.id === lang);

  return language ? `${language.id} - ${language.value}` : lang;
};

const LanguageItem = ({
  id,
  title,
  isSelected,
  isDeleteDisabled,
  viewOnly,
  hasError,
  onSelect,
  onEdit,
  onDelete
}) => {
  const [deleteModalActive, setDeleteModalActive] = useState(false);

  return (
    <>
      <LanguageItemWrapper
        id={id}
        Container={FlexContainers.FlexRowBetween}
        width={"100%"}
        height={40}
        gap={8}
        ph={10}
        pv={8}
        isSelected={isSelected}
        onClick={onSelect}>
        <WrapperContainer Container={FlexContainers.FlexRowStart} gap={8}>
          <Paragraph2>{getLanguageName(title)}</Paragraph2>

          {hasError && (
            <IconButton tooltipLabel={t(strCode.MISSING_CONTENT_INFO)} xShift={-16}>
              <SVG.MissingContentIcon />
            </IconButton>
          )}
        </WrapperContainer>

        <WrapperContainer Container={FlexContainers.FlexRowStart} gap={8}>
          {!viewOnly && (
            <>
              {!isDeleteDisabled && (
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteModalActive(true);
                  }}
                  disabled={isDeleteDisabled || viewOnly}
                  tooltipLabel={t(strCode.DELETE_BTN)}>
                  <SVG.DeleteIcon />
                </IconButton>
              )}

              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit();
                }}
                disabled={viewOnly}
                tooltipLabel={t(strCode.EDIT)}>
                <SVG.EditIcon />
              </IconButton>
            </>
          )}
        </WrapperContainer>
      </LanguageItemWrapper>

      <DeleteLanguageModal
        active={deleteModalActive}
        setActive={setDeleteModalActive}
        title={title}
        onDelete={() => onDelete(id)}
      />
    </>
  );
};

LanguageItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  isDeleteDisabled: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  viewOnly: PropTypes.bool.isRequired,
  hasError: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default LanguageItem;
